import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import DefaultModal from '../modals/DefaultModal';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import useDefaultModal from '../hooks/useDefaultModal';

function ElementoDespesaModal({ show, onHide, elementodespesa, onSuccess }) {
  const [formData, setFormData] = useState({
    cnpjAssociacao: '',
    id: '',
    descricao: '',
  });
  const token = localStorage.getItem('token');
  const cnpj = localStorage.getItem('cnpj');
  const { setDefaultModal, showDefaultModal } = useDefaultModal();

  useEffect(() => {
    if (!show) {
      setFormData({
        cnpjAssociacao: cnpj,
        id: '',
        descricao: '',
      });
    } else if (elementodespesa) {
      setFormData({
        ...elementodespesa,
        descricao: elementodespesa.descricao
          ? elementodespesa.descricao.toUpperCase()
          : '',
      });
    } else {
      setFormData({
        cnpjAssociacao: cnpj,
        id: '',
        descricao: '',
      });
    }
  }, [show, elementodespesa]);

  function handleChange(event) {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value.toUpperCase(),
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
    const elementodespesaParaSalvar = {
      ...formData,
      cnpjAssociacao: cnpj,
    };

    axios
      .post(
        `${API_BASE_URL.ELEMENTO_DESPESA}/save`,
        elementodespesaParaSalvar,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(() => {
        // Fechar o modal primeiro
        onHide();
        // Depois mostrar a mensagem de sucesso
        showDefaultModal('success', 'O registro foi salvo com sucesso!', () => {
          onSuccess();
        });
      })
      .catch(error => {
        console.error('Erro ao salvar elemento de despesa:', error);
        showDefaultModal('error', 'Erro ao salvar o registro!');
      });
  }

  return (
    <>
      <Modal show={show} onHide={onHide} centered>
        <Modal.Header
          closeButton
          className={
            elementodespesa ? 'bg-primary text-white' : 'bg-success text-white'
          }
          style={{ height: '30px' }}
        >
          <Modal.Title className="fs-5">
            {elementodespesa ? 'Editar Elemento de Despesa' : 'Novo Elemento de Despesa'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="col-md-12 input-group-sm">
                <label className="form-label">Nome</label>
                <input
                  onChange={handleChange}
                  value={formData.descricao}
                  name="descricao"
                  type="text"
                  className="form-control text-uppercase" // Adiciona classe para exibir em maiúsculas
                  required
                />
              </div>

              <div className="col-md-12 mb-3 input-group-sm d-flex justify-content-end">
                <Button variant="danger" onClick={onHide} className="mx-1">
                  <i className="bi bi-x-lg" /> Cancelar
                </Button>
                <Button type="submit" variant="success" className="mx-1">
                  <i className="bi bi-check-lg" /> Salvar
                </Button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <DefaultModal {...setDefaultModal} />
    </>
  );
}

export default ElementoDespesaModal;
